// 数据相关接口
import request from '@/utils/request'

// 分页查询用户意见反馈列表
export function memberFeedbackPageList(query) {
  return request({
    url: '/biz/memberFeedback/pageList',
    method: 'get',
    params: query
  })
}

// 获取用户意见反馈详细信息
export function memberFeedbackDetails(params) {
  return request({
    url: `/biz/memberFeedback/getInfo`,
    method: 'get',
    params
  })
}

// 修改用户意见反馈
export function memberFeedbackEdit(params) {
  return request({
    url: '/biz/memberFeedback/edit',
    method: 'put',
    data: params
  })
}

// 查询参数配置列表
export function paramConfigList(query) {
  return request({
    url: '/biz/paramConfig/list',
    method: 'get',
    params: query
  })
}

// 修改参数类型
export function bizParamConfig(params) {
  return request({
    url: '/biz/paramConfig',
    method: 'put',
    data: params
  })
}

// 启用禁用
export function paramConfigUpdateIsEnable(data) {
  return request({
    url: '/biz/paramConfig/updateIsEnable',
    method: 'put',
    params: data,
  })
}

// 分页查询消息管理列表
export function messagePageList(query) {
  return request({
    url: '/biz/message/pageList',
    method: 'get',
    params: query
  })
}

// 查询消息模板列列表
export function businessMsgList(query) {
  return request({
    url: '/biz/businessMsg/list',
    method: 'get',
    params: query
  })
}

// 新增消息模板列
export function businessMsg(data) {
  return request({
    url: '/biz/businessMsg',
    method: 'post',
    data
  })
}

// 导出消息模板列列表
export function businessMsgExport(data) {
  return request({
    url: '/biz/message/export',
    method: 'post',
    data
  })
}

// 启用禁用
export function businessMsgUpdateIsEnable(data) {
  return request({
    url: '/biz/businessMsg/updateIsEnable',
    method: 'put',
    params: data
  })
}
